import { render, staticRenderFns } from "./PannelloTecnici.vue?vue&type=template&id=0aae04a9&scoped=true&"
import script from "./PannelloTecnici.vue?vue&type=script&lang=js&"
export * from "./PannelloTecnici.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aae04a9",
  null
  
)

export default component.exports